// @flow
import { useContext } from 'react';

import { FEDRAMP_ENABLED_BACKEND_NAME } from '../components/fedramp/constants';
import { EstimateContext } from '../contexts/EstimateContext';

export const useIsFedRAMPEstimate = () => {
  const estimate = useContext(EstimateContext);
  const isFedRAMPEstimate = estimate?.inputs?.[FEDRAMP_ENABLED_BACKEND_NAME] === true;

  return isFedRAMPEstimate;
};
